import type { BootstrapRequest, BootstrapResponse } from "../types";

export class BootstrapError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = "BootstrapError";
    this.status = status;
  }
}

export async function bootstrapSession(
  agentUrl: string,
  payload: BootstrapRequest,
): Promise<BootstrapResponse> {
  const base = agentUrl.replace(/\/$/, "");
  const res = await fetch(`${base}/chat/sessions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    let message = `HTTP ${res.status}`;
    try {
      const body = (await res.json()) as { error?: string };
      if (body?.error) message = body.error;
    } catch {
      // empty / non-JSON body — keep the HTTP-status fallback
    }
    throw new BootstrapError(message, res.status);
  }

  return (await res.json()) as BootstrapResponse;
}
